<template>
  <v-container id="contact" fluid>
    <v-row justify="center">
      <v-col class="col-md-4">
        <v-card>
          <v-container fluid>
            <v-row>
              <v-col
                v-for="n in 9"
                :key="n"
                class="d-flex child-flex"
                cols="4"
              >
                <v-card flat tile class="d-flex">
                  <v-img
                    :src="`https://picsum.photos/500/300?image=${n * 5 + 10}`"
                    :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>

      <v-col class="col-md-4">
        <v-form
          ref="form"
          v-model="form"
          class="pa-4 pt-6"
        >
          
          <v-text-field
            v-model="fullname"
            filled
            color="blue"
            label="Full Name"
          ></v-text-field>
          <v-text-field
            v-model="email"
            :rules="[rules.email]"
            filled
            color="blue"
            label="Email Address"
            type="email"
          ></v-text-field>
          <v-textarea
            v-model="comments"
            auto-grow
            filled
            color="blue"
            label="Comments"
            rows="5"
            row-height="50"
          ></v-textarea>
          <v-checkbox
            v-model="agreement"
            :rules="[rules.required]"
            color="blue"
          >
            <template v-slot:label>
              I agree to the
              <a class="ma-1" href="#" @click.stop.prevent="dialog = true">Terms of Service</a>
              and 
              <a class="ma-1" href="#" @click.stop.prevent="dialog = true">Privacy Policy</a>*
            </template>
          </v-checkbox>
        </v-form>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            text
            @click="$refs.form.reset()"
          >
            Clear
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-on:click="enquire"
            :disabled="!form"
            :loading="isLoading"
            class="white--text"
            color="blue accent-4"
            depressed
          >Submit</v-btn>
        </v-card-actions>
        <v-dialog
          v-model="dialog"
          absolute
          max-width="400"
          persistent
        >
          <v-card>
            <v-card-title class="headline grey lighten-3">Legal</v-card-title>
            <v-card-text>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn
                text
                @click="agreement = false, dialog = false"
              >
                No
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                class="white--text"
                color="blue accent-4"
                @click="agreement = true, dialog = false"
              >
                Yes
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      agreement: false,
      comments: '',
      dialog: false,
      email: undefined,
      form: false,
      isLoading: false,
      fullname: undefined,
      rules: {
        email: v => (v || '').match(/@/) || 'Please enter a valid email',
        length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
        required: v => !!v || 'This field is required',
      },
    }),
    methods: {

      enquire: async function(event) {
        console.log("Event: " + event)

        const rawResponse = await fetch('https://nlmiifb5uh.execute-api.ap-southeast-1.amazonaws.com/prod/enquire', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({fullName: this.fullname, emailAddress: this.email, comments: this.comments})
        })

        const content = await rawResponse.json()

        if (content.isVerified === 0) {
          //console.log("IsVerified: " + content.isVerified)
          this.$emit("enquire-successful", content.createAt)
        }
      }

    }
  }
</script>